import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
// import { IonicPageModule } from "ionic-angular"
import { CommonModule } from "@angular/common";
import { DefaultHeaderComponent } from "./default-header/default-header";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";

import { MenuModule } from "./menu-components.module";




@NgModule({
	declarations: [DefaultHeaderComponent],
	imports: [
        CommonModule,
        MatToolbarModule,
        MatIconModule,
		MatMenuModule,
		MenuModule,
	],
	exports: [
		DefaultHeaderComponent,
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})

export class HeaderModule { }
